import moment from 'moment';
export const hasETACrossed = (dueDateStr) => {
    let dueDate = moment(dueDateStr);
    let currentDate = moment();
    let diffDays = dueDate.diff(currentDate, 'days');
    if (diffDays <= 3 && diffDays >= 0) {
        return 1;
    } else if (diffDays < 0) {
        return 2
    } else {
        return 3;
    }

}